import { Component } from '@angular/core'

/**
 * This component is a placeholder when no tabs are returned from the API.
 * This only happens with placeholder events and is not common.
 * Without this component added in events-routing module, we get this error
 * One of the following must be provided: component, loadComponent, redirectTo, children or loadChildren
 */
@Component({
  selector: 'flo-empty-tab',
  template: ''
})
export class EmptyTab {}
